export const MOCK_ACCOUNT_DETAILS = {
  entity: {
    name: 'Epilot GmbH',
    customer_number: '2312312',
    tax_exemption: false,
    _schema: 'account',
    _id: 'c76f0d6f-8d4e-4cda-9619-8b1b85eae31d',
    _org: '911744',
    _owners: [
      {
        org_id: '911744',
        user_id: '11001152'
      }
    ],
    _created_at: '2025-11-25T14:53:23.144Z',
    _updated_at: '2025-12-12T10:20:10.550Z',
    _title: 'Epilot GmbH',
    _acl: {
      view: ['org_911744'],
      edit: ['org_911744'],
      delete: ['org_911744']
    },
    assigned_to: [
      {
        type: 'user',
        user_id: '11001152',
        display_name: 'Florian Fuchs',
        org_id: '911744',
        email: 'florian.fuchs@epilot.cloud',
        phone: null
      }
    ]
  },
  relations: []
}
